import { supabase } from '../../supabase.client';

const useOnboardingApi = () => {
  const fetchOnboardingState = async (userId) => {
    try {
      const { data, error } = await supabase
        .from('onboarding_state')
        .select()
        .eq('id', userId)
        .limit(1)
        .maybeSingle();
      if (error) {
        throw error;
      }
      return data;
    } catch (error) {
      console.error(error);
      return null;
    }
  };

  const upsertOnboardingState = async (userId, payload) => {
    try {
      const { data, error } = await supabase
        .from('onboarding_state')
        .upsert(
          {
            id: userId,
            ...payload,
            updated_at: new Date().toISOString(),
          },
          { onConflict: 'id' }
        )
        .select()
        .single();
      if (error) {
        throw error;
      }
      return data;
    } catch (error) {
      console.error(error);
      return null;
    }
  };

  const hideOnboarding = async (userId) => {
    return upsertOnboardingState(userId, { dismissed: true });
  };

  const showOnboarding = async (userId) => {
    return upsertOnboardingState(userId, { dismissed: false });
  };

  return {
    fetchOnboardingState,
    upsertOnboardingState,
    hideOnboarding,
    showOnboarding,
  };
};

export default useOnboardingApi;
